import React from 'react';

import UserSkeleton from '~/boilerplates/User';
import Survey from '~/containers/User/NPS/Survey';
import { SurveyContextProvider } from '~/contexts/NPS/SurveyContext';
import { SurveyPrivilegesContextProvider } from '~/contexts/NPS/SurveyPrivilegesContext';

export default function SurveyPage() {
  return (
    <UserSkeleton>
      <SurveyPrivilegesContextProvider>
        <SurveyContextProvider>
          <Survey />
        </SurveyContextProvider>
      </SurveyPrivilegesContextProvider>
    </UserSkeleton>
  );
}
